export default __webpack_public_path__ + "static/sticker-2-31e4a6ced0fe2a7ca494d64d5e1f0e87.png";